import { atom } from 'recoil'
import { IProjectCheckpoint } from '../../projectCheckpoints.types'

interface IProjectCheckpointsTableAtom {
  items: IProjectCheckpoint[]
}

const checkpointsTableAtom = atom<IProjectCheckpointsTableAtom>({
  key: 'tables/admin/project-checkpoints',
  default: { items: [] },
})
export default checkpointsTableAtom
